import classNames from 'classnames'
import * as React from 'react'
import type {HTMLAttributes} from 'react'

import type {OSType} from '../../../../../types'
import {osIconMap} from '../../../../common/AgentLink/AgentLink'
import SvgIcon from '../../../../common/SvgIcon/SvgIcon'
import MatchingTitle, {MatchingHighlight} from '../MatchingItem/MatchingItem'

import styles from './LinearAgent.css'

type Props = HTMLAttributes<HTMLDivElement> & {
  title?: string
  cloud?: boolean
  connected?: boolean | null
  enabled?: boolean | null
  osType?: OSType | null | undefined
  matching?: boolean
  searchQuery?: string
}
export default function LinearAgent({
  title,
  cloud,
  matching,
  className,
  connected,
  enabled,
  osType,
  searchQuery,
  ...htmlProps
}: Props) {
  const icon = osType != null ? osIconMap[osType] : null

  return (
    <span
      className={classNames(className, {
        [styles.disconnected]: connected === false,
        [styles.disabled]: enabled === false,
      })}
      {...htmlProps}
    >
      {icon != null && (
        <SvgIcon
          className={classNames(styles.icon, osType === 'macOS' && styles.macOs)}
          icon={icon}
          data-test-sidebar-agent={'os-icon'}
        />
      )}
      {cloud === true && matching === true ? (
        <MatchingHighlight>{title}</MatchingHighlight>
      ) : (
        <MatchingTitle searchQuery={searchQuery}>{title}</MatchingTitle>
      )}
      {connected === false ? (
        <>
          {' '}
          <SvgIcon className={styles.disconnectedIcon} icon="disconnected" title="disconnected" />
        </>
      ) : null}
    </span>
  )
}
